import { render, staticRenderFns } from "./AttachmentEditForm.vue?vue&type=template&id=4c6655c0&"
import script from "./AttachmentEditForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports